module.exports = __webpack_public_path__ + "img/pumpcharge.6faa0ea2.svg";